import {
  Button,
  mainTheme,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import { useMediaQuery } from '@material-ui/core';
import React, { memo, useState } from 'react';
import { User } from 'src/types';
import { getFlatOrgsLength } from 'src/utils/transformers';
import ChangeOrganisationDialog from '../ChangeOrganisationDialog/ChangeOrganisationDialog';
import { useStyles } from './styles';

interface IAccountCard {
  user: User;
}

const AccountCard: React.FC<IAccountCard> = ({ user }) => {
  const [changeOrganisationOpen, setChangeOrganisationOpen] = useState(false);
  const numberOfOrganisations = getFlatOrgsLength(user.organisations);
  const isSm = useMediaQuery(mainTheme.breakpoints.down('sm'));
  const isXs = useMediaQuery(mainTheme.breakpoints.down('xs'));
  const classes = useStyles({
    hasOrganisations: numberOfOrganisations > 1,
    isXs,
  });
  return (
    <div data-testid="userPanel">
      <Typography
        variant={isSm ? 'h3' : 'h2'}
        className={classes.helloMessage}
        data-testid="helloMessage"
      >
        Hello {user.firstName}
      </Typography>
      {!!numberOfOrganisations && (
        <div
          data-testid="organisationPanel"
          className={classes.organisationPanel}
        >
          <Typography variant="body1">
            {user.organisationLegacyNumber
              ? `${user.organisationLegacyNumber} - ${user.organisationName}`
              : user.organisationName}
          </Typography>
          {numberOfOrganisations > 1 && (
            <Button
              size="small"
              variant="text"
              data-testid="changeOrganisation-link"
              onClick={() => {
                sessionStorage.setItem('tabIndex', '0');
                setChangeOrganisationOpen(true);
              }}
            >
              Change organisation
            </Button>
          )}
        </div>
      )}
      <ChangeOrganisationDialog
        open={changeOrganisationOpen}
        onClose={(selected) =>
          (user.organisationId || selected) && setChangeOrganisationOpen(false)
        }
      />
    </div>
  );
};

export default memo(AccountCard);
